import React from "react";
import { dispatch } from '@rematch/core';
import ArrangementPane from './ArrangementPane'
import BreadCrumbsPage from './../../drive/cards/BreadCrumbs'
//import SwimTable from './../../drive/tables/swimLineTable'
class SwimLineView extends React.Component {

  componentWillMount() {
    dispatch.app.setRouteParams(this.props.match.params)
    dispatch.lifeCycle.setArrangementPaneFlag(false)
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.displaySecondMenu(null)
  }

  render() {

    return (
      <div className="pad_20" >
        <ArrangementPane {...this.props} setPage="Schedule" />
        <BreadCrumbsPage {...this.props} />
        {/* <SwimTable {...this.props} /> */}
      </div>
    );
  }
}
export default SwimLineView;
